.root {
  color: white;
  font-weight: 400;
  text-underline-offset: var(--mantine-spacing-sm);
  text-decoration-thickness: 2px;

  &[aria-current], &:hover {
    text-decoration: underline;
  }
}
